import React, { Component } from 'react';
import Header from '../components/Header';
import Inner from '../components/Inner';

export default class Terms extends Component {
    render() {
        return (
            <div>
                <Header title="Vilkår og betingelser" />
                <Inner>
                    <div className="mainContainer">
                        <div className="mainContainerText">
                            <p>Fristberegneren er et gratis værktøj, som kan benyttes til at beregne frister i udbudsprocedurer.
                    Brugere, der anvender Fristberegneren og hjemmesiden, <a href="/">www.fristberegneren.dk</a>,
                                med tilhørende undersider (herefter ”Hjemmesiden”), accepterer at være bundet af nedenstående
                    vilkår.</p>
                            <p>Fristberegneren og Hjemmesiden er udviklet af Kammeradvokaten, Advokatfirmaet Poul Schmith
                    (herefter ”Udvikleren”).</p>
                            <p>Udvikleren har bestræbt sig på at sikre, at Hjemmesidens oplysninger er korrekte, og at
                                Fristberegneren beregner de korrekte resultater. Der gives dog ingen direkte eller indirekte
                                garanti for oplysningernes eller beregningernes korrekthed, og Udvikleren påtager sig intet
                                ansvar for fejl eller mangler af nogen som helst art. Anvendelse af Fristberegneren erstatter
                                således ikke juridisk rådgivning og skaber ikke et klientforhold mellem brugeren og
                    Udvikleren.</p>
                            <p>Udvikleren påtager sig intet ansvar for et eventuelt tab som følge af brug af Fristberegneren
                                eller Hjemmesiden, hvad enten tabet skyldes fejl eller uhensigtsmæssigheder i Fristberegneren
                    eller Hjemmesiden eller andre årsager.</p>
                            <p>Fristberegneren ejes af Udvikleren, og de immaterielle rettigheder til Fristberegneren og
                    Hjemmesiden, herunder ophavsrettigheder til materialet på Hjemmesiden, tilhører Udvikleren.</p>
                            <p>Der må linkes til Hjemmesiden ved almindelige referencelinks. Deeplinking og framing samt andre
                                former for links, der slører Udvikleren, er ikke tilladt. Hverken Hjemmesiden eller materiale
                                herfra, f.eks. billeder og logo mv., må kopieres eller anvendes i anden sammenhæng, uden at
                    tilladelse fra Udvikleren er indhentet.</p>
                        </div>
                    </div>
                </Inner>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Terms.js